
class LeLazyTool extends HTMLElement {
    constructor() {
        super();

        this.lazyHtmls = null
        this.lazyNodes = null

        this.init()
    }

    init() {
        this.lazyNodes = $.map($('.ld-scroll-load-mode').get(), function (i) { return $(i); })

        this.onScrollHandler = this.customThrottle(this.onScroll.bind(this), 200);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.onScroll()
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        if (this.lazyHtmls && this.lazyNodes && this.lazyNodes.length > 0) {
            var loadedIndex = []
            this.lazyNodes.forEach((node, index) => {
                if (this.isInViewport(node)) {
                    var type = node.attr('type')
                    var dataHtml = this.lazyHtmls[type]
                    if (type) {
                        node.append(dataHtml).addClass('ld-scroll-load-show')
                        node.css({ height: 'initial' })

                        this.addHtml(type)

                        loadedIndex.unshift(index);
                    }
                }
            })
            loadedIndex.forEach((index) => {
                this.lazyNodes.splice(index, 1)
            })
        }
    }

    addHtml() { }

    isInViewport($el) {
        const elementTop = $el.offset().top
        const elementBottom = elementTop + $el.outerHeight()
        const viewportTop = $(window).scrollTop()
        const viewportBottom = viewportTop + $(window).height()

        return elementBottom > viewportTop && elementTop < viewportBottom
    }

    customThrottle(fn, delay) {
        var last = 0
        return function () {
            var now = Date.now()
            if (now - last >= delay) {
                last = now
                fn.apply(this, arguments)
            }
        }
    }
}

customElements.define('le-lazy-tool', LeLazyTool);